
      import Pic from './pic.vue'
      import type { App, Plugin } from 'vue'

      export const PicPlugin: Plugin = {
        install(app: App) {
          app.component('Pic', Pic)
        },
      }
      export { Pic }
      